"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleLabel = void 0;
var react_1 = __importDefault(require("react"));
var techsee_base_component_1 = require("../../../_shared/techsee-base-component");
require("./styles.scss");
var mobx_react_1 = require("mobx-react");
var SimpleLabel = /** @class */ (function (_super) {
    __extends(SimpleLabel, _super);
    function SimpleLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleLabel.prototype.renderInternal = function () {
        this.addCssClass('simple-label');
        this.addCssClass(this.props.className);
        var attrs = {
            className: this.renderCssClasses()
        };
        if (this.props.labelFor) {
            attrs.htmlFor = this.props.labelFor;
        }
        if (this.props.dir) {
            attrs.dir = this.props.dir;
        }
        return react_1.default.createElement("label", __assign({}, attrs), this.props.children);
    };
    SimpleLabel = __decorate([
        mobx_react_1.observer
    ], SimpleLabel);
    return SimpleLabel;
}(techsee_base_component_1.TechseeBaseComponent));
exports.SimpleLabel = SimpleLabel;
